module.exports = __webpack_public_path__ + "img/lg.06275eb8.png";